/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Ilo Nomena Portfolio",
  description:
    "Développeur .NET senior et Fullstack, possédant une solide expérience pratique. Je prends en charge l'intégralité des projets, de la conception technique à la livraison",
  og: {
    title: "Ilo Nomena Portfolio",
    type: "website",
    url: "https://ilonomena.github.io/",
  },
};

const getYearsOfExperience = () => {
    const startYear = 2018;
    const currentYear = new Date().getFullYear();
    return currentYear - startYear;
  };

//Home Page
const greeting = {
  title: "Ilo Nomena, Dev C# .NET",
  logo_name: "IloNomena",
  nickname: "FullStack .NET",
  yearsOfExperience : getYearsOfExperience(),
  subTitle:
    "Développeur .NET senior et Fullstack, possédant une solide expérience pratique. Je prends en charge l'intégralité des projets, de la conception technique à la livraison",
  resumeLink:
    "https://drive.google.com/file/d/1_eC4LsCueiTXlFMes_yUnABqj7YVrMx5/view?usp=sharing",
  githubProfile: "https://github.com/ilonomena",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/ilonomena",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/ilo-nomena-razafindramanana-a08a47176/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:ilonomenarazi@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/profile.php?id=61594178882945",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/ilonomena_/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Développement Fullstack",
      fileName: "FullStackImg",
      skills: [
          "⚡ Développement d'applications performants avec .NET, C#: MVC, API REST, bibliothèques de classes, MicroServices, applications cloud et serverless...",
          "⚡ Expérience multi-versions .NET : 4.7, .NET Core 3.1, 6, 7, 8, 9, 10...",
          "⚡ Maîtrise des patterns d'architecture avancés : Monolithe modulaire, DDD, Clean Architecture, CQRS etc..",
          "⚡ Qualité de code élevée : respect des bonnes pratiques, principes SOLID et utilisation de design patterns pour assurer maintenabilité et scalabilité",
          "⚡ Analyse et conception d’architectures logicielles et de bases de données adaptées aux besoins métier et aux contraintes techniques",
          "⚡ Intégration d'interfaces front-end responsive avec React, Angular, HTML5, CSS3, Bootstrap, Material UI, Tailwind..",
          "⚡ Conception et optimisation de bases de données PostgreSQL, MySQL, NoSQL",
          "⚡ Utilisation d'Entity Framework, Dapper, NHibernate etc.. pour l'accès aux données (ORM)",
          "⚡ Optimisations et performances des applications"
      ],

      softwareSkills: [
        {
          skillName: "C#",
          fontAwesomeClassname: "logos:c-sharp",
          style: {
            color: "#c726e3ff",
          },
        },
        {
          skillName: "API REST",
          fontAwesomeClassname: "eos-icons:api-outlined",
          style: {
            color: "#3bc1d2ff",
          },
        },
        {
          skillName: "MicroServices",
          fontAwesomeClassname: "carbon:microservices-1",
          style: {
            color: "#3bc1d2ff",
          },
        },
        {
          skillName: ".NET",
          fontAwesomeClassname: "skill-icons:dotnet",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "React",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Angular",
          fontAwesomeClassname: "skill-icons:angular-light",
          style: {
            backgroundColor: "#ffffffff",
            color: "#EDF9FE",
          },
        },
        {
          skillName: "Blazor",
          fontAwesomeClassname: "devicon:blazor",
          style: {
            backgroundColor: "#ffffffff",
            color: "#EDF9FE",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "devicon:postgresql",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "SQL",
          fontAwesomeClassname: "logos:mysql",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Entity Framework",
          fontAwesomeClassname: "devicon:entityframeworkcore",
          style: {
            color: "#2C8EBB",
          },
        }
      ],
    },
    {
      title: "Cloud & Application Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Déploiement d'applications cloud sur Azure (Azure App Services / Azure Container Apps), AWS et Google Cloud Platform",
        "⚡ Conteneurisation des applications avec Docker",
        "⚡ Mise en place d'environnements scalables et haute disponibilité",
        "⚡ Automatisation du déploiement et gestion d'infrastructure cloud",
        "⚡ Choix de solutions cloud et stratégies de déploiement optimales selon le budget client, avec estimation précise des coûts d’infrastructure"
      ],

      softwareSkills: [
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
      ],
    },
    {
      title: "Team Lead",
      fileName: "TeamLeadImg",
      imagePath: "TeamLeadImg.png",
      skills: [
        "⚡ Leadership technique et prise de décision éclairée",
        "⚡ Application pratique des méthodes Agile / Scrum pour livrer des projets efficacement",
        "⚡ Organisation, gestion de priorités et respect des deadlines",
        "⚡ Revues de codes",
        "⚡ Participation à la montée en compétence des profils juniors",
        "⚡ Brainstorming et co-création d’idées pour solutions techniques",
        "⚡ Partage de connaissance"
      ],

      softwareSkills: [
        {
          skillName: "Lead Dev",
          fontAwesomeClassname: "fluent-mdl2:party-leader",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Formation des juniors",
          fontAwesomeClassname: "mdi:teach-poll",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "Code review",
          fontAwesomeClassname: "octicon:code-review-16",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Partage",
          fontAwesomeClassname: "streamline-freehand:programming-team-chat",
          style: {
            color: "#1488C6",
          },
        },
      ],
    }
  ],
};

// Experience Page
const experience = {
  title: "Parcours professionnel",
  subtitle: "Depuis 2018 à aujourd'hui",
  description:
    "Fort de mes expériences en tant que développeur .NET Full Stack, j'ai accompagné des startups innovantes et des entreprises établies dans la conception et la livraison de solutions logicielles robustes. Architecte technique et développeur senior, je maîtrise l'ensemble du cycle de vie des projets, de l'architecture à la mise en production.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Clients et Projets",
      work: true,
      experiences: [
        {
          title: "Développeur .NET en full remote",
          company: "CODICEO",
          company_url: "https://codiceo.fr/",
          logo_path: "codiceo.jpg",
          period: "2023 — 2026",
          highlights: [
            "Seul développeur back (API) aux côtés du lead tech",
            "Conception d'API REST, bases de données et migrations",
          ],
          tags: [
            ".NET Core",
            "API REST",
            "PostgreSQL",
            "Entity Framework",
            "Docker",
          ],
          duration: "Juin 2023 - Avril 2026",
          location: "Lyon - France",
          description: "Seul développeur responsable de toute la partie back (API), à part le lead tech.",
          color: "#000000",
        },
        {
          title: "Développeur FULLSTACK .NET en full remote",
          company: "YouScribe",
          company_url: "https://www.youscribe.com/",
          logo_path: "youscribe.png",
          period: "2021 — 2023",
          highlights: [
            "OAuth2, OpenID Connect et SSO pour les partenaires",
            "Découpage en microservices et microfrontends",
            "CI/CD sur Azure DevOps, migration vers .NET Core",
          ],
          tags: [
            ".NET Core",
            "C# MVC",
            "PostgreSQL",
            "Redis",
            "RabbitMQ",
            "Azure DevOps",
          ],
          duration: "Octobre 2021 - Juin 2023",
          location: "Paris - France",
          description:
            "J’ai développé de nouvelles fonctionnalités, mis en place OAuth2.0, OpenIdConnect et SSO pour les partenaires, travaillé sur le découplage en microservices et microfrontends, résolu des problèmes de ressources partagées, amélioré les outils internes, corrigé des bugs, ajouté des fonctionnalités aux APIs mobiles, assuré la maintenance et la migration vers .NET Core, construit des pipelines CI/CD sur Azure DevOps et développé le module d’organigramme des collaborateurs.",
          color: "#0879bf",
        },
        {
          title: "Développeur .NET / .NET Core",
          company: "BOCASAY",
          company_url: "https://www.bocasay.com/fr/madagascar-fr/",
          logo_path: "bocasay.jpg",
          period: "2021",
          highlights: [
            "Module Statistiques et Graphes pour My Company Files",
            "SharePoint et Text Extract, indexation et recherche ElasticSearch",
            "API pour l'application mobile",
          ],
          tags: [
            ".NET",
            "SQL Server",
            "ElasticSearch",
            "SharePoint",
          ],
          duration: "Janvier 2021 - Octobre 2021",
          location: "Antananarivo - Madagascar",
          description:
            "Pour le client My Company Files, j’ai entièrement développé le module Statistiques et Graphes, résolu les bugs, créé des customisations pour chaque cabinet, travaillé sur les modules SharePoint et Text Extract avec indexation dans ElasticSearch et smart search, tout en collaborant étroitement avec le développeur mobile pour fournir les API nécessaires.",
          color: "#9b1578",
        },
        {
          title: "Développeur .NET / Kentico / Angular ",
          company: "WAZO, Editus.lu",
          company_url: "https://www.wazo.lu/fr/",
          logo_path: "wazo.png",
          period: "2019 — 2020",
          highlights: [
            "Socle en .NET Core 3 / Angular 6, analyste et concepteur",
            "Sites et modules sur mesure : paiements (PayPal, SixPayment, Mollie), TVA, remises",
            "Chat en temps réel, tâches planifiées, timbres personnalisés",
          ],
          tags: [
            ".NET Core",
            "Angular",
            "Kentico",
            "SQL Server",
          ],
          duration: "Janvier 2019 - Décembre 2020",
          location: "Luxembourg",
          description:
            "J’ai participé à la construction des socles matrices, développé des sites et modules personnalisés incluant les paiements (Paypal, SixPayment, Molly), les timbres personnalisés, les tâches planifiées, le chat en temps réel, les calculs de TVA, remises et remboursements, tout en construisant le socle en .NET Core 3 / Angular 6 et en intervenant comme analyste et concepteur.",
          color: "#fc1f20",
        },
        {
          title: "Développeur PHP Symfony",
          company: "Innocorp EC",
          company_url: "",
          logo_path: "EC.jpg",
          period: "2018",
          highlights: [
            "Interfaces utilisateurs",
            "Gestion des privilèges",
            "Rédaction du cahier des charges",
          ],
          tags: [
            "PHP",
            "Symfony",
          ],
          duration: "2018 CDD",
          location: "Antananarivo - Madagascar",
          description:
            "J’ai participé à l’implémentation des interfaces utilisateurs, à la gestion des privilèges et à la rédaction du cahier des charges.",
          color: "#fc1f20",
        },
      ],
    },
    {
      title: "Bénévolats",
      experiences: [
        {
          title: "Refonte du site FJKM Atsimon'Imahamasina",
          company: "FJKM",
          company_url: "https://www.fjkm.mg/",
          logo_path: "fjkm.jpg",
          period: "2017",
          highlights: [],
          tags: [],
          duration: "2017",
          location: "Antananarivo Madagascar",
          description:"",
          color: "#4285F4",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Réalisations",
  description:
    "Au fil des années, j’ai participé à la conception et au développement de nombreux projets, allant de la création de modules personnalisés pour des backoffices complexes à la mise en place d’architectures microservices et de pipelines CI/CD sur Azure DevOps. J’ai travaillé sur des projets de portails clients, des API robustes, des interfaces utilisateurs réactives, des systèmes de paiement en ligne, ainsi que des modules d’indexation et recherche intelligente. Chaque projet m’a permis d’allier performance, maintenabilité et expérience utilisateur, tout en collaborant étroitement avec les équipes métiers et partenaires.Ces réalisations reflètent ma capacité à gérer des projets de bout en bout, du cahier des charges à la livraison, en passant par le développement, la maintenance et l’optimisation continue.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contactez moi",
    profile_image_path: "ilo_contact.png",
    description:
      "Je suis disponible sur la plupart des réseaux sociaux et réponds généralement sous 24 heures. Je peux vous accompagner et vous conseiller sur des sujets liés au développement .NET fullstack, APIs, applications web, architectures microservices, Azure et DevOps. N’hésitez pas à poser vos questions ou à me proposer des projets, je serai ravi d’échanger avec vous !",
  },
  addressSection: {
    title: "Adresse",
    subtitle: "Ambatoroka Tsiadana - Antananarivo 101 Madagascar",
    locality: "Antananarivo",
    country: "Madagascar",
    region: "Antananarivo",
    postalCode: "101",
    streetAddress: "",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/Mpq89rzMQ52ZAi5q8",
  },
  phoneSection: {
    title: "Téléphone",
    subtitle: "+261 32 94 267 33",
  },
};


// TESTIMONIALS 

const testimonies = [
  {
    id: 1,
    image: 'asou.jpg',
    name: 'Aurélien SOUVIGNET • CEO / CTO Codiceo',
    text: "J'ai eu le plaisir de travailler avec Ilo au sein de CODICEO, et je peux dire sans hésiter que sa contribution a été vraiment remarquable ! En tant que développeur back-end sur .NET Core, il a su prendre en main des sujets variés et exigeants : conception et développement d'APIs REST robustes, gestion des bases de données et migrations, ainsi que des réflexions d'architecture back-end solides."
          + "\n"
          + "Ilo fait partie de ces profils qui vont au-delà du simple développement : rigoureux, proactif et force de proposition, il a su s'intégrer rapidement et livrer un travail de qualité tout au long de sa mission. C'est exactement le type de collaborateur qu'on est heureux d'avoir dans son équipe."
          + "\n "
          + "Je recommande chaleureusement Ilo pour toute mission back-end — il saura être un vrai atout pour n'importe quelle équipe tech !" ,
  },
  {
    id: 2,
    image: 'diary.jpg',
    name: 'Diary RAOELISON • Chef de projet - UI/UX Designer',
    text: "J’ai collaboré avec Ilo sur des projets web et j’ai particulièrement apprécié la solidité de ses compétences techniques (architecture, qualité de code, bonnes pratiques). Il développe des solutions propres, performantes et maintenables."
          +"\n"
          +"A la fois fiable, rigoureux et force de proposition sur le stack à utiliser, il comprend rapidement les enjeux et apporte de vraies solutions. Un profil que je recommande sans hésitation à tout chef de projet qui souhaite mettre dans son équipe un développeur fullstack.",
  },  
  {
    id: 3,
    image: 'fregate.jpg',
    name: 'Frégate • Chef de projet .NET',
    text: "Fiable et efficace, il se distingue par sa rapidité à trouver des solutions pertinentes. Un professionnel sur qui l’on peut compter pour livrer un travail de qualité dans les délais.",
  },
];


export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  experience,
  projectsHeader,
  contactPageData,
  testimonies
};
